// Opening move: Define Lexical node configuration for reboot editor
// Starting with built-in Lexical nodes, now adding custom nodes as epics progress
// Big play: Each epic adds ONE focused node type with comprehensive tests

import type { Klass, LexicalNode } from 'lexical'
import { TextNode } from 'lexical'
import { SectionBlockNode } from '../nodes/SectionBlockNode'
import { LyricsTextNode } from '../nodes/LyricsTextNode'

// Main play: Register custom nodes for editor features
// Built-in nodes (ParagraphNode, LineBreakNode, RootNode) are registered automatically
// Time to tackle the tricky bit: TextNode replacement requires special config format
// Reference: .local_docs/lexical/core-docs/01-nodes.md - Node Replacement Options
export const nodes: Array<Klass<LexicalNode> | { replace: typeof LexicalNode; with: (node: LexicalNode) => LexicalNode; withKlass: typeof LexicalNode }> = [
  // Epic 01: Section tagging - wraps paragraphs with section metadata (verse/chorus/bridge/outro/intro)
  SectionBlockNode,

  // Epic 02: Stress data infrastructure - replace TextNode with LyricsTextNode
  // CRITICAL: LyricsTextNode must be registered FIRST, then the replacement config
  LyricsTextNode,

  // Big play: Every text node in editor now participates in stress pattern storage
  // Victory lap: NodeState keeps stress data headless (no DOM changes until Epic 03 rendering)
  // CRITICAL: 'with' function receives the original node and must copy its text content
  // Reference: .local_docs/lexical/core-docs/01-nodes.md line 175-185
  {
    replace: TextNode,
    with: (node: LexicalNode) => {
      // Opening move: Get text content from the original TextNode
      const textNode = node as TextNode
      const text = textNode.getTextContent()
      // Victory lap: Create LyricsTextNode with the same text content
      return new LyricsTextNode(text)
    },
    withKlass: LyricsTextNode,
  },
]

// Victory lap: Clean node registration with systematic epic progression
// - Epic 01: Section tagging (SectionBlockNode)
// - Epic 02: Stress data infrastructure (LyricsTextNode replacement)
// Future: Epic 03 will add stress rendering, Epic 04 override menu, etc.
